/**
 * CheckoutStepProject Component
 */
/* tslint:disable:no-submodule-imports */

import { consumeLocallyStoredStep } from '../../../redux/actions/checkout';
import { FieldDate } from '../../../redux/form/utils';
import { generateLicenseUsageFromComponents } from '../../../redux/helpers/license';
// import { validateString } from '../../../utils/string';
import { getResponsiveTrackThumbnail } from '../../../utils/track';

import { get, isEmpty } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { Field, FormProps, reduxForm } from 'redux-form';

import TextFieldOnly from '../../atoms/forms/TextField';
import Thumbnail from '../../atoms/images/Thumbnail';
import Heading from '../../atoms/text/Heading';
import { Span } from '../../atoms/text/Label';
import FormCell from '../../molecules/forms/FormCell';
import FormRow from '../../molecules/forms/FormRow';
import TextArea from '../../molecules/forms/TextAreaWithLabel';
import TextField from '../../molecules/forms/TextFieldWithLabel';
import CheckoutStep from './CheckoutStep';
import { CheckoutStepFormName, CheckoutStepId } from './config';

interface IOwnProps extends FormProps<any, any, {}> {
  order: GQL.IOrder;
}

type IOwnStateProps = Pick<CheckoutStepProjectProps, 'initialValues'>;

interface IOwnMergedProps {
  consumeLocalStorage: () => void;
}

type CheckoutStepProjectProps = IOwnProps & IOwnMergedProps;

interface IFormFields {
  airDate: { [usageId: string]: string };
  brand: string;
  notes: string;
  poNumber: string;
  product: string;
  reference: string;
}

export type CheckoutStepProjectFormFields = IFormFields;

const formValidations: IFormValidations = {
  // brand: {
  //   validator: validateString,
  //   error: 'Is it a valid brand name?',
  // },
  // product: {
  //   validator: validateString,
  //   error: 'Is it a valid product name?',
  // },
};

const stepId = CheckoutStepId.project;
const form = CheckoutStepFormName.project;
const classes = new BEM(`checkout__step--${stepId}`);

class CheckoutStepProject extends React.Component<CheckoutStepProjectProps, {}> {

  componentDidMount() {
    this.props.consumeLocalStorage();
  }

  renderAirDates = (lineItem: GQL.ILicenseLineItem, index: number) => {
    const track = lineItem.track!;
    const image = getResponsiveTrackThumbnail(track);
    const usages = lineItem.license!.usages!.map(
      ({ id, components }) => generateLicenseUsageFromComponents(components!, id),
    );
    return (
      <div key={lineItem.id} {...classes('license-item') }>
        <div {...classes('license-item__track') }>
          <Thumbnail responsiveAssets={image} size="xsmall" {...classes('license-item__track__image') } />
          <div {...classes('license-item__track__info') }>
            <Heading is="h5" text={track.title!} maxTextLength={15} {...classes('license-item__track__info__title') } />
            <Span
              text={track.artist!.name!}
              size="small"
              textColor="bw7"
              {...classes('license-item__track__info__subtitle') }
            />
          </div>
        </div>
        <div {...classes('license-item__usages') }>
          {usages.map((usage, i) => (
            <div key={`usage-${track.id}-${i}`} {...classes('license-item__usage') }>
              <Heading
                is="h5"
                WrappedComponent="div"
              >{usage.medium.name}
              </Heading>
              <FieldDate
                component={TextFieldOnly}
                name={`airDate.${usage.id}`}
                colorScheme="white"
                placeholder="YYYY/MM/DD"
                onlyValidateIfTouched
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    const {
      order,
      error,
      handleSubmit,
      submitting,
    } = this.props;

    return (
      <CheckoutStep
        defaultSelected
        error={error}
        formValidations={formValidations}
        id={stepId}
        handleSubmit={handleSubmit!}
        submitting={submitting}
        title="Project Details"
      >
        <div {...classes('product-data') }>
          <Heading is="h5">Tell us about your project.</Heading>
          <FormRow>
            <FormCell minimumWidth="full">
              <Field
                name="brand"
                component={TextField}
                label="Brand"
                colorScheme="light"
                autoFocus
              />
            </FormCell>
          </FormRow>
          <FormRow>
            <FormCell minimumWidth="full">
              <Field
                name="product"
                component={TextField}
                label="Project Title"
                colorScheme="light"
              />
            </FormCell>
          </FormRow>
        </div>
        <div {...classes('internal-data') }>
          <Heading is="h5">This information is for your own use.<br />It will be displayed on your invoice.</Heading>
          <FormRow>
            <FormCell minimumWidth={8}>
              <Field
                name="poNumber"
                component={TextField}
                label="PO Number"
                colorScheme="light"
                optional
              />
            </FormCell>
            <FormCell spacer minimumWidth={1} />
            <FormCell minimumWidth={8}>
              <Field
                name="reference"
                component={TextField}
                label="Reference"
                colorScheme="light"
                optional
              />
            </FormCell>
          </FormRow>
          <FormRow>
            <FormCell minimumWidth="full">
              <Field
                name="notes"
                component={TextArea}
                label="Notes"
                colorScheme="light"
                optional
              />
            </FormCell>
          </FormRow>
        </div>
        <div {...classes('licenses')}>
          <Heading is="h5">Approximate air date for each media:</Heading>
          {order.license_line_items!.map(this.renderAirDates)}
        </div>
      </CheckoutStep>
    );
  }
}

const CheckoutStepProjectForm = reduxForm<IFormFields, CheckoutStepProjectProps, any>({
  form,
})(CheckoutStepProject);

const ConnectedCheckoutStepProject = connect(
  ({ checkout: { localStorage } }: IStoreState, ownProps: IOwnProps): IOwnStateProps => ({
    initialValues: localStorage && get(localStorage, stepId, {}),
  }),
  (dispatch): IOwnMergedProps => ({
    consumeLocalStorage: () => dispatch(consumeLocallyStoredStep({ id: stepId })),
  }),
  (stateProps, dispatchProps, ownProps): CheckoutStepProjectProps => ({
    ...ownProps,
    ...stateProps,
    consumeLocalStorage: () => !isEmpty(stateProps.initialValues) && dispatchProps.consumeLocalStorage(),
  }),
)(CheckoutStepProjectForm);

export default ConnectedCheckoutStepProject;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/CheckoutStepProject.tsx